import { BULK_ADD_TO_CART_SET_RESULT, BULK_ADD_TO_CART_SET_STEP, BULK_ADD_TO_CART_STEPS, BULK_ADD_TO_CART_VISIBILITY, BULK_ADD_TO_CART_SET_INPUT_VALUE, BULK_ADD_TO_CART_SET_LOADING_STATE, BULK_ADD_TO_CART_SET_STATE } from '../constants';
import { translate as t } from "../Services/translation";
const devMode = true;
const developmentResult = [
    { variantId: "BRA701352-1", success: true, message: "" },
    { variantId: "BRA701352-2", success: true, message: "" },
    { variantId: "BRA701352-3", success: true, message: "" },
    { variantId: "BRA701352-4", success: true, message: "" },
    { variantId: "BRA701352-5", success: true, message: "" },
    { variantId: "BRA701352-7", success: false, message: t('nmas.bulkaddtocart.result.message.productisunavailable') }
];
export const LoadingStates = {
    IDLE: 'idle',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
};
const initialState = {
    step: BULK_ADD_TO_CART_STEPS.SUMMARY,
    visible: false,
    result: devMode ? developmentResult : [],
    inputValue: '',
    loadingState: LoadingStates.IDLE
};
export const bulkAddToCart = (state = initialState, action) => {
    switch (action.type) {
        case BULK_ADD_TO_CART_SET_STATE:
        case BULK_ADD_TO_CART_VISIBILITY:
        case BULK_ADD_TO_CART_SET_LOADING_STATE:
            return {
                ...state,
                ...action.payload,
            };
        case BULK_ADD_TO_CART_SET_STEP:
            return {
                ...state,
                step: action.payload,
            };
        case BULK_ADD_TO_CART_SET_RESULT:
            return {
                ...state,
                result: action.payload,
            };
        case BULK_ADD_TO_CART_SET_INPUT_VALUE:
            return {
                ...state,
                inputValue: action.payload,
            };
        default:
            return state;
    }
};
